import { Component, OnInit } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";
import * as moment from "moment";
import { RA } from "src/models/sisreg";
import { STATUS_RA, SisREGService } from "src/services/sisreg.service";

@Component({
  selector: "solicitacoes-reguladas-list-component",
  templateUrl: "./solicitacoes-reguladas-list.component.html",
  styleUrls: ["./solicitacoes-reguladas-list.component.scss"],
})
export class SolicitacoesReguladasListComponent implements OnInit {
  emptyState = {
    imgUrl: "/assets/imgs/bg-agendamentos-regulados.svg",
    title: "O paciente não possui registros de Agendamentos Regulados",
    text: "Esta área é dedicada à disponibilização de solicitações reguladas para a realização de consultas, procedimentos e exames provenientes dos sistemas informatizados de Regulação Assistencial.",
  };

  emptyStateFiltered = {
    imgUrl: "/assets/imgs/bg-agendamentos-regulados.svg",
    title:
      "O paciente não possui registros de Agendamentos Regulados com o filtro aplicado",
    text: "Esta área é dedicada à disponibilização de solicitações reguladas para a realização de consultas, procedimentos e exames provenientes dos sistemas informatizados de Regulação Assistencial, com o filtro aplicado.",
  };

  userFiltro: any;
  procedimentoSelecionado: any;
  caraterSelecionado: any;
  list: any = [];
  procedimentosData: any = [];
  caraterAtendimentoData: any = [];

  solicitacoesList: RA[] = [];
  solicitacoesListFiltered: any[] = [];
  dtFim: any;
  dtInicio: any;
  conteudoRevelado = false;
  listaFiltroProcedimento: any[] = [];
  listaFiltroStatus: any[] = [];
  filtrosSelecionados: any[] = [];

  constructor(
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private sisREGService: SisREGService
  ) { }

  async ngOnInit() {
    await this.loadData();

    this.listaFiltroStatus = Object.values(STATUS_RA).map(
      (status) => status.label
    );

    this.solicitacoesList.forEach((sol) => {
      if (!this.listaFiltroProcedimento.includes(sol.procedimento)) {
        this.listaFiltroProcedimento.push(sol.procedimento);
      }
    });
  }

  async loadData() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    try {
      this.solicitacoesList = await this.sisREGService.getList();

      //   this.listMock.forEach((atendimento) =>
      //   this.atendimentosList.push(atendimento)
      // );

      this.formatarConteudo(false);
    } catch (e) {
      console.error("error", e);
    }

    await loading.dismiss();
  }

  formatarConteudo(hidden: boolean) {
    this.solicitacoesListFiltered = this.solicitacoesList.map((sol) => ({
      tipo: "SOLICITACAO REGULADA",
      nome: sol.procedimento,
      dtAtualizacao: sol.execucao.data,
      status: sol.status,
      dtSolicitacao: sol.solicitacao.data,
      telefoneSolicitacao: sol.solicitacao.telefone,
      enderecoSolicitacao: sol.solicitacao.endereco,
      modalidade: sol.modalidadeAmbulatorial,
      especialidade: sol.especialidade,
      motivo: sol.motivoSolicitacao,
      estabelecimento: sol.solicitacao.nome,
      dtExecucao: sol.execucao.data,
      telefoneExecucao: sol.execucao.telefone,
      enderecoExecucao: sol.execucao.endereco,
    }));

    if (hidden) {
      this.solicitacoesListFiltered = this.solicitacoesListFiltered.splice(
        0,
        3
      );
    }
  }

  revelarConteudo() {
    this.formatarConteudo(false);
    this.conteudoRevelado = true;
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.solicitacoesListFiltered = this.solicitacoesListFiltered.filter(
        (atendimento) => {
          const dtAtendimento = moment(atendimento.dtExecucao, "DD/MM/YYYY");
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");

          return dtAtendimento.isBetween(dtInicio, dtFim);
        }
      );
    }

    if (this.filtrosSelecionados.length) {
      const procedimentosSelecionados = this.filtrosSelecionados
        .filter((f) => f.tipo === "procedimento")
        .map((f) => f.data);
      const statusSelecionados = this.filtrosSelecionados
        .filter((f) => f.tipo === "status")
        .map((f) => f.data);

      console.log(procedimentosSelecionados)

      this.solicitacoesListFiltered = this.solicitacoesListFiltered.filter(
        (sol) => {
          let count = 0;

          if (procedimentosSelecionados) {
            if (procedimentosSelecionados.includes(sol.nome)) {
              count += 1;
            }
          }

          if (statusSelecionados) {
            const statusLabel = STATUS_RA[sol.status];
            if (statusSelecionados.includes(statusLabel.label)) {
              count += 1;
            }
          }
          return !!count;
        }
      );
    }
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    const filtro = {
      tipo,
      data,
    };

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }

    this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.formatarConteudo(false);
    this.filter();
  }
}
